"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavigationItem = void 0;
const react_1 = __importDefault(require("react"));
const spa_core_1 = require("@episerver/spa-core");
const NavigationItem = (props) => {
    var _a;
    const linkProps = {
        title: props.item.linkLabel,
        target: '_self',
        className: 'py-4 py-md-5 px-3 px-md-2 d-inline-block',
        href: props.item.linkUrl
    };
    const handleKeyDown = (e) => {
        if (e.code === 'ArrowRight' || e.code === 'Space' || e.code === 'Enter') {
            e.preventDefault();
            props.openLevel(props.item.linkUrl, props.currentLevel);
        }
        if (e.code === 'ArrowLeft' || e.code === 'Escape') {
            e.preventDefault();
            props.removeLastLevel();
        }
    };
    const handleDownForNavItem = (e) => {
        if (e.code === 'ArrowLeft' || (e.code === 'Escape' && !e.target.closest('.collapse.show'))) {
            e.preventDefault();
            props.removeLastLevel();
        }
        else if (e.code === 'Escape' && e.target.closest('.collapse.show')) {
            e.preventDefault();
            props.collapseToggle();
        }
    };
    const handleCollapseKeyDown = (e) => {
        if (e.code === 'ArrowDown' && e.target.getAttribute('aria-expanded') === 'false') {
            e.preventDefault();
            props.collapseToggle();
        }
        else if ((e.code === 'ArrowUp' || e.code === 'Escape') && e.target.getAttribute('aria-expanded') === 'true') {
            e.preventDefault();
            props.collapseToggle();
        }
        else if (e.code === 'Escape' && e.target.getAttribute('aria-expanded') === 'false') {
            e.preventDefault();
            props.removeLastLevel();
        }
        else if (e.code === 'Space' || e.code === 'Enter') {
            e.preventDefault();
            props.collapseToggle();
        }
    };
    const nextLevel = react_1.default.createElement("a", { role: 'button', tabIndex: 0, className: 'icon-nav-caret d-flex align-items-center justify-content-center h-100 ms-auto', onKeyDown: handleKeyDown, onClick: () => props.openLevel(props.item.linkUrl, props.currentLevel) },
        react_1.default.createElement("span", { className: 'visually-hidden' },
            react_1.default.createElement(spa_core_1.Components.Property, { iContent: props.labels, field: 'toNextMenuLevel' })));
    return react_1.default.createElement("li", { className: `nav-item navlink px-7 px-md-0 ms-md-2 d-flex ${props.needle === props.item.linkUrl ? 'path-from-needle' : ''} ${props.currentUrl.indexOf(props.item.linkUrl) != -1 ? 'path-to-active' : ''} ${props.currentUrl === props.item.linkUrl ? 'active' : ''}` },
        react_1.default.createElement("span", { suppressHydrationWarning: true, className: 'd-flex align-items-center flex-grow-1 nav-sep' },
            react_1.default.createElement("a", Object.assign({}, linkProps, { onClick: () => props.closeNav(props.item.linkUrl), onKeyDown: handleDownForNavItem }), props.item.linkLabel),
            !props.lastItem && props.item.subItems.length > 0 ?
                nextLevel
                : react_1.default.createElement(react_1.default.Fragment, null),
            (props === null || props === void 0 ? void 0 : props.collapseToggle) && ((_a = props.item.subItems) === null || _a === void 0 ? void 0 : _a.length) > 0 ? react_1.default.createElement("a", { role: 'button', tabIndex: 0, className: 'icon-nav-caret last-level d-flex align-items-center justify-content-center h-100 ms-auto', onKeyDown: handleCollapseKeyDown, onClick: () => props.collapseToggle(), "aria-controls": props.ariaControls, "aria-expanded": props.ariaExpanded, "aria-current": props.currentUrl === props.item.linkUrl ? 'page' : null },
                react_1.default.createElement("span", { className: 'visually-hidden' },
                    react_1.default.createElement(spa_core_1.Components.Property, { iContent: props.labels, field: 'toNextMenuLevel' }))) : react_1.default.createElement(react_1.default.Fragment, null)),
        react_1.default.createElement("span", { className: 'right-space d-block ms-auto me-0' }));
};
exports.NavigationItem = NavigationItem;
exports.default = exports.NavigationItem;
